/**
 *
 * NotFound
 *
 */

import { Helmet } from 'react-helmet-async';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { NotFoundError } from '@ts/utils/errors';
import TripshockCardInfo from '@ts/components/TripshockCardInfo';
import useWebPCheckSupport from '@ts/utils/useWebPCheckSupport';
import * as S from '@ts/containers/NotFoundPage/styles';

import backgroundImage from '@ts/images/404-bg-0.5x.png';
import backgroundImageWebP from '@ts/images/404-bg-0.5x.webp';

export function NotFound({ destinations = [] }) {
    const [isOpen, setIsOpen] = React.useState(false);
    const props = React.useMemo(
        () => ({
            height: isOpen ? '514px' : '72px',
            bottom: isOpen ? '-90px' : '26px',
        }),
        [isOpen]
    );
    const allState = React.useMemo(
        () =>
            destinations.map(
                (sortState) =>
                    sortState.state.code + ' - ' + sortState.name + ';;;' + sortState.url_search
            ),
        [destinations]
    );
    const sortState = React.useMemo(() => allState.sort(), [allState]);
    const items = React.useMemo(
        () =>
            sortState.map((state) => {
                return state.split(';;;');
            }),
        [sortState]
    );
    React.useEffect(() => {
        try {
            console.log(new NotFoundError(), { location: window.location }, ['commons:NotFound']);
        } catch {}
    }, []);

    const WebP = useWebPCheckSupport();

    return (
        <S.Section
            data-test-id="not-found"
            backgroundImage={WebP ? backgroundImageWebP : backgroundImage}
            isOpen={isOpen}
        >
            <Helmet>
                <title>TripShock - 404 Page Not Found</title>
            </Helmet>
            <TripshockCardInfo textAlign="left" isNotFoundType={true} isOpen={isOpen}>
                <S.WrapperForText>
                    <S.Title data-test-id="title">
                        We couldn’t find the adventure you are looking for
                    </S.Title>
                    <S.Text data-test-id="description">
                        Don’t worry you can choose your destination below and we will get you right
                        back on track.
                    </S.Text>
                </S.WrapperForText>
                <S.SearchSelector style={props}>
                    <S.SearchSelectorHeader onClick={() => setIsOpen(!isOpen)}>
                        <span>{isOpen ? '' : 'select your destination'}</span>
                        <S.Arrow />
                    </S.SearchSelectorHeader>
                    <S.SearchSelectorItems>
                        <S.SearchSelectorScroll>
                            {items.map((item) => {
                                return (
                                    <S.SearchSelectorItem to={item[1]} key={item[0]}>
                                        {item[0]}
                                    </S.SearchSelectorItem>
                                );
                            })}
                        </S.SearchSelectorScroll>
                    </S.SearchSelectorItems>
                </S.SearchSelector>
            </TripshockCardInfo>
        </S.Section>
    );
}

export default withRouter(NotFound);
